module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.413b6b9.ttf";